import { LayoutGap } from '@philips-internal/oswald-ui-constants';
import { ComponentAPI } from '@philips-internal/oswald-ui-core';
import { isEnumValid } from '@philips-internal/oswald-ui-utils';
class DashboardAPI extends ComponentAPI {
    /**
     * Returns the rows gap.
     */
    getRowGap() {
        return this.state.rowGap;
    }
    /**
     * Sets the gap between rows.
     *
     * @param rowGap - The gap value.
     */
    setRowGap(rowGap) {
        if (isEnumValid(LayoutGap, rowGap)) {
            this.setState({ rowGap });
        }
    }
    /**
     * Returns the columns gap
     */
    getColumnGap() {
        return this.state.columnGap;
    }
    /**
     * Sets the gap between columns.
     *
     * @param columnGap - The gap value.
     */
    setColumnGap(columnGap) {
        if (isEnumValid(LayoutGap, columnGap)) {
            this.setState({ columnGap });
        }
    }
}
export { DashboardAPI, };
//# sourceMappingURL=dashboard-api.js.map